import { useState } from "react";
import { Link } from "react-router-dom";
import questionsByCategory from "./questions-by-category.js";
import Question from "../../components/Question.js";

const Home = () => {
  const [utcTimeZone, setUtcTimeZone] = useState(
    new Date().getTimezoneOffset() / -60
  );
  const [numDevelopersToConnectTo, setNumDevelopersToConnectTo] = useState(3);
  const [email, setEmail] = useState("");
  const [answers, setAnswers] = useState({});

  return (
    <section className="home">
      <nav>
        Home
        <span> | </span>
        <Link to="/about">About</Link>
        <span> | </span>
        <a href="mailto:adamzerner@protonmail.com">Contact</a>
        <span> | </span>
        <a href="https://www.buymeacoffee.com/adamzerner">Buy Me A Coffee</a>
      </nav>
      <p>
        <em>
          Note: This project has been shut down. See{" "}
          <a href="https://adamzerner.bearblog.dev/reflections-on-connect-developers/">
            this blog
          </a>{" "}
          post.
        </em>
      </p>
      <h1>Video chat with like-minded developers</h1>
      <p>
        Answer as many of the questions below as you'd like and click submit.
        Once you do, you will be put in touch with other developers via email
        who had answers most similar to yours. From there, you guys can arrange
        an introductory video call.
      </p>
      <p>
        <Link to="/about">Learn more</Link>
      </p>
      <section className="questions">
        {questionsByCategory.map(({ category, questions }) => (
          <section className="category" key={category}>
            <h4>{category}</h4>
            {questions.map(({ id, left, right }) => (
              <Question
                key={id}
                left={left}
                right={right}
                answer={answers[id]}
                onAnswer={(answer) => {
                  setAnswers({
                    ...answers,
                    [id]: answer,
                  });
                }}
              />
            ))}
          </section>
        ))}
      </section>
      <section className="preferences">
        <label>
          Connect me with up to this many developers
          <input
            type="number"
            min={1}
            max={10}
            value={numDevelopersToConnectTo}
            onChange={(e) => {
              setNumDevelopersToConnectTo(e.target.value);
            }}
          />
        </label>
        <label>
          Time zone (UTC)
          <input
            type="number"
            min="-12"
            max="14"
            value={utcTimeZone}
            onChange={(e) => {
              setUtcTimeZone(e.target.value);
            }}
          />
        </label>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <button disabled>Submit</button>
      </section>
    </section>
  );
};

export default Home;
